import { Box, Container, Typography } from "@material-ui/core"
import {
  clearApiToken,
  getOrderGetOrderGiftCardSharingText,
  getPassV1GetGoogleOrderPassUrl,
  getPassV1GetOrderApplePassUrl,
} from "api"
import { useIsDesktop } from "common/MediaQueries"
import { useGroupPurchasesContext } from "components/PurchasePage/GroupPurchasesContext"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import NextLink from "components/Reusable/Bit/NextLink"
import moment from "moment"
import { useRouter } from "next/router"
import { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import conffeti from "../../../../public/animation/Conffeti.json"
import successPayment from "../../../../public/animation/Purchase successful.json"

import { isVisible } from "common/utils/isVisible"
import GenericButton from "components/GenericButton/GenericButton"
import WhatsappIcon from "components/Icons/PaymentWhatsappIcon"
import TelegramIcon from "components/Icons/TelegramIcon"
import { shareSocialNetworkLinks } from "components/Reusable/Functions/Functions"
import dynamic from "next/dynamic"
import Image from "next/image"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledWrapper = styled.div<{
  $conffeti: boolean
  $isGroupPurchase?: boolean
}>`
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  position: ${(p) => (p.$conffeti ? "absolute" : "initial")};
  ${(p) => p.theme.breakpoints.up("md")} {
    width: ${(p) => !p.$conffeti && (p.$isGroupPurchase ? "405px" : "450px")};
    height: ${(p) => (p.$conffeti ? "auto" : "275px")};
    svg {
      transform: ${(p) =>
        p.$conffeti ? " scale(1) !important;" : "scale(1.5) !important;"};
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    height: ${(p) => (p.$isGroupPurchase ? "250px" : "300px")};
    margin-top: 80px;
    top: ${(p) => p.$conffeti && 0};
  }
`
const StyledName = styled(Typography).attrs({ variant: "h4" })<{
  $margin: boolean
}>`
  margin-top: ${(p) => (p.$margin ? "30px" : "0px")};
  font-size: 40px;
  text-align: right;
  font-family: Speedee, NarkisBlock;
  line-height: normal;

  ${(p) => p.theme.breakpoints.down("sm")} {
    text-align: center;
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  color: ${(p) => p.theme.colors.black};
  font-size: 40px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 40px;
    line-height: 0.8;
    margin-bottom: 5px;
  }
`

const StyledText = styled(Typography).attrs({ variant: "body1" })<{
  $isGroupPurchase?: boolean
}>`
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
    line-height: 0.92;
    ${(p) => p?.$isGroupPurchase && "margin-top: 20px;"}
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 275px;
  }
`

const StyledLinksWrapper = styled.div<{
  $pathname?: string
  $isGroupPurchase?: boolean
}>`
  display: flex;
  gap: 24px;
  align-items: center;
  margin-top: 30px;

  margin-top: ${(p) => (p.$isGroupPurchase ? "44px" : "20px")};

  ${(p) => p.theme.breakpoints.up("sm")} {
    margin-top: ${(p) => (p.$isGroupPurchase ? "40px" : "30px")};
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`

const StyledButtonWrapper = styled.div<{
  $pathname?: string
  $isGroupPurchase?: boolean
}>`
  display: flex;
  justify-content: ${(p) =>
    p?.$pathname === "/groupPurchases/payment" ? "center" : "flex-start"};

  ${(p) => p.theme.breakpoints.down("sm")} {
    justify-content: center;
    flex-direction: column;
    padding-top: 12px;
  }
`

const StyledBoxWrapper = styled(Box)<{ $isGroupPurchase?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${(p) => (p.$isGroupPurchase ? "30px" : "0px")};
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: column;
    align-items: ${(p) => (p.$isGroupPurchase ? "center" : "start")};
    margin-right: ${(p) => (p.$isGroupPurchase ? "0px" : "70px")};
    margin-bottom: ${(p) => (p.$isGroupPurchase ? "40px" : "0px")};
  }
`
const StyledBox = styled(Container)<{ $isGroupPurchase?: boolean }>`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: ${(p) => (p.$isGroupPurchase ? "column" : "row")};
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    margin-top: 120px;
  }
`

const StyledIconsWrapper = styled(Box)<{ $isMobile?: boolean }>`
  margin-top: ${(p) => (p?.$isMobile ? "40" : "22")}px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 9;
`

const StyledShareText = styled(Typography).attrs({ variant: "h3" })`
  font-family: "NarkisBlock";
  font-weight: bold;
  margin-bottom: 10px;

  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;
  }
`

const StyledLottie = styled(Lottie)`
  position: relative;
  z-index: -1;
`

const StyledSvgDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  ${(p) => p.theme.breakpoints.down("sm")} {
    justify-content: center;
  }
  gap: 16px;
`

const StyledSvgWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    cursor: pointer;
  }
`

const StyledImage = styled(Image)`
  cursor: pointer;
`

const StyledGiftcardLottie = styled(Lottie)``

const SuccessPayment = () => {
  const { purchaseData, blessingMode, orderRecipientGuid, groupPurchaseGuid } =
    usePurchaseContext()
  const { groupPurchasesData } = useGroupPurchasesContext()
  const { pathname } = useRouter()

  const ref = useRef(null)
  const [text, setText] = useState("")
  const isDesktop = useIsDesktop()
  const router = useRouter()
  const isGroupPurchase = router.pathname.includes("groupPurchases")

  const handleAppleWalletClick = async () => {
    const response = await getPassV1GetOrderApplePassUrl(orderRecipientGuid)
    const walletUrl = response?.data?.body
    setTimeout(() => {
      window.open(walletUrl, "_blank", "noopener,noreferrer")
    })
  }

  const handleGoogleWalletClick = async () => {
    const response = await getPassV1GetGoogleOrderPassUrl(orderRecipientGuid)
    const walletUrl = response?.data?.body
    setTimeout(() => {
      window.open(walletUrl, "_blank", "noopener,noreferrer")
    })
  }

  useEffect(() => {
    if (document) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }

    !isGroupPurchase && clearApiToken()

    // Scroll to top of page on page load
    if (window) {
      window.scrollTo(0, 0)
    }
  }, [])

  useEffect(() => {
    ref?.current?.setSpeed(0.8)
  }, [ref])

  useEffect(() => {
    if (orderRecipientGuid) {
      const getData = async () => {
        const { data } = await getOrderGetOrderGiftCardSharingText(
          orderRecipientGuid,
          groupPurchaseGuid
        )
        setText(data.body)
      }
      getData()
    }
  }, [orderRecipientGuid])

  const purchaseDate = () => {
    const weekDays = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"]
    const date = purchaseData?.messagesScheduleDate
      ? purchaseData.messagesScheduleDate
      : null
    if (!date) return { header: "הגיפטקארד נשלח עכשיו!", text: "" }
    if (date) {
      const minute = moment(date).format("HH:mm")
      const dateFormat = moment(date).format("DD.MM.YY")
      if (moment().format("L") === moment(date).format("L"))
        return {
          header: "הגיפטקארד יישלח במועד שביקשת!",
          text: `היום, ${dateFormat}, בשעה ${minute}`,
        }
      else if (moment().add(1, "days").format("L") === moment(date).format("L"))
        return {
          header: "הגיפטקארד יישלח במועד שביקשת!",
          text: `מחר, ${dateFormat}, בשעה ${minute}`,
        }
      else
        return {
          header: "הגיפטקארד יישלח במועד שביקשת!",
          text: `ביום ${
            weekDays[moment(date).day()]
          }, ${dateFormat}, בשעה ${minute}`,
        }
    }
  }

  return (
    <StyledBox $isGroupPurchase={isGroupPurchase}>
      <StyledWrapper $conffeti={false} $isGroupPurchase={isGroupPurchase}>
        <StyledGiftcardLottie
          animationData={successPayment}
          lottieRef={ref}
          loop={true}
        />
      </StyledWrapper>
      <StyledWrapper $conffeti={true}>
        {isDesktop && <StyledLottie animationData={conffeti} loop={true} />}
        <StyledLottie animationData={conffeti} loop={true} />
      </StyledWrapper>
      <StyledBoxWrapper $isGroupPurchase={isGroupPurchase}>
        {!isGroupPurchase ? (
          <>
            {blessingMode === "full" ? (
              <StyledName $margin={false}>
                איזה כיף! שימחת את {purchaseData?.recipientName}
              </StyledName>
            ) : (
              <StyledName $margin={false}>איזה כיף!</StyledName>
            )}

            <StyledTitle>{purchaseDate().header}</StyledTitle>

            {!purchaseData?.messagesScheduleDate ? (
              <StyledText>
                ברגעים אלו אנחנו שולחים עדכון על קבלת הגיפטקארד בהודעה
              </StyledText>
            ) : (
              <StyledText>{purchaseDate().text}</StyledText>
            )}

            {isDesktop && (
              <StyledIconsWrapper>
                <StyledShareText>אפשר לשתף את המתנה מכאן</StyledShareText>
                <StyledSvgDiv>
                  <StyledSvgWrapper
                    onClick={() =>
                      window.open(
                        isDesktop
                          ? shareSocialNetworkLinks(text).whatsapp.desktop
                          : shareSocialNetworkLinks(text).whatsapp.mobile
                      )
                    }
                  >
                    <WhatsappIcon />
                  </StyledSvgWrapper>
                  <StyledSvgWrapper
                    onClick={() =>
                      window.open(
                        isDesktop
                          ? shareSocialNetworkLinks(text).telegram.desktop
                          : shareSocialNetworkLinks(text).telegram.mobile
                      )
                    }
                  >
                    <TelegramIcon />
                  </StyledSvgWrapper>
                </StyledSvgDiv>
              </StyledIconsWrapper>
            )}
          </>
        ) : (
          <>
            <StyledName $margin={true}>הקבוצה נוצרה בהצלחה!</StyledName>
            <StyledText $isGroupPurchase={isGroupPurchase}>
              {!isGroupPurchase
                ? "כניסה לניהול ההזמנה ניתן להיכנס תמיד לעמוד היתרות שלי"
                : " כדי לנהל את ההזמנה ניתן להיכנס תמיד לעמוד היתרות שלי "}
            </StyledText>
          </>
        )}

        {!isDesktop && (
          <StyledIconsWrapper $isMobile={true}>
            <StyledShareText>אפשר לשתף את המתנה מכאן</StyledShareText>
            <StyledSvgDiv>
              <StyledSvgWrapper
                onClick={() =>
                  window.open(
                    isDesktop
                      ? shareSocialNetworkLinks(text).whatsapp.desktop
                      : shareSocialNetworkLinks(text).whatsapp.mobile
                  )
                }
              >
                <WhatsappIcon />
              </StyledSvgWrapper>
              <StyledSvgWrapper
                onClick={() =>
                  window.open(
                    isDesktop
                      ? shareSocialNetworkLinks(text).telegram.desktop
                      : shareSocialNetworkLinks(text).telegram.mobile
                  )
                }
              >
                <TelegramIcon />
              </StyledSvgWrapper>
            </StyledSvgDiv>
          </StyledIconsWrapper>
        )}

        <StyledLinksWrapper
          $pathname={pathname}
          $isGroupPurchase={isGroupPurchase}
        >
          <NextLink
            href={
              isGroupPurchase
                ? //@ts-ignore
                  `/balance/groupPurchase?groupCardID=${
                    //@ts-ignore
                    groupPurchasesData.guid || ""
                  }`
                : "/"
            }
            style={{
              alignSelf: "stretch",
            }}
          >
            <StyledButtonWrapper
              $pathname={pathname}
              $isGroupPurchase={isGroupPurchase}
            >
              <GenericButton btnType="filled" width={190} mobileWidth={155}>
                {isGroupPurchase ? "ממשיכים" : "לחזרה לעמוד הבית"}
              </GenericButton>
            </StyledButtonWrapper>
          </NextLink>

          {!isGroupPurchase && blessingMode !== "full" && (
            <>
              {isVisible("ios") && (
                <StyledImage
                  src="/apple-wallet.svg"
                  alt="apple wallet"
                  width={153}
                  height={46}
                  onClick={handleAppleWalletClick}
                />
              )}

              {isVisible("android") && (
                <StyledImage
                  src="/google-wallet.svg"
                  alt="apple wallet"
                  width={153}
                  height={46}
                  onClick={handleGoogleWalletClick}
                />
              )}
            </>
          )}
        </StyledLinksWrapper>
      </StyledBoxWrapper>
    </StyledBox>
  )
}

export default SuccessPayment
